import React from 'react';
import '../../styles/components/_footer.scss';
import {
  BroadcastIcon,
  LocationIcon,
  MailIcon,
  PhoneIcon,
  PrinterIcon,
  WhatsappIcon,
} from '../Icons/SiteIcons';

function FooterSecond() {
  return (
    <footer className="footer-second">
      <div className="footer-container">
        <div className="row">
          <div className="col-md-2">
            <div className="footer-logo">
              <a href="/"><img src="/assets/images/logo.png" alt="Belediye Logo" /></a>
            </div>
          </div>
          <div className="col-md-3">
            <div className="footer-widget">
              <div className="footer-widget-second">
                <ul>
                  <li><a href="tel:905305421939"><PhoneIcon /> Telefon: +90 530 542 19 39</a></li>
                  <li><a href="tel:4441939"><PrinterIcon /> Fax: 444 1 939</a></li>
                  <li><a href="mailto:belediye@iskenderun.bel.tr"><MailIcon /> E-Posta: belediye@iskenderun.bel.tr</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="footer-widget">
              <div className="footer-widget-second">
                <ul>
                  <li>
                    <a
                      href="https://maps.google.com/?q=Yenisehir%20Maresal%20Fevzi%20Cakmak%20Cd.%20No:48%20Iskenderun%20Hatay"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LocationIcon /> Adres: Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay
                    </a>
                  </li>
                  <li><a href="tel:4441939"><BroadcastIcon /> Santral: 444 1 939</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="footer-widget">
              <div className="footer-widget-butt">
                <a href="https://wa.me/905305421939" target="_blank" rel="noopener noreferrer">
                  <WhatsappIcon /> Whatsapp Destek Hattı
                </a>
                <a href="/iletisim">Bize Ulaşın</a>
              </div>
            </div>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
    </footer>
  );
}

export default FooterSecond;
